<template>
  <v-container id="experience">
    <p class="text-h2 text-center my-10">Work experience</p>
    <v-row
      v-for="i in experienceMenu"
      :key="i.title"
      id="project-view"
      data-aos="fade-up"
      class="mt-10 justify-center align-center"
    >
      <v-col cols="12" md="5">
        <div class="head-text">
          <span class="text-h3 text-md-left">
            {{ i.title }}
            <br />
            <span v-for="icon in i.icons" :key="icon">
              <v-icon large>{{ icon }}</v-icon>
            </span>
          </span>
          <p class="font-italic text-h5 text-md-left">{{ i.date }}</p>
          <v-divider class="subtext-divider" />
        </div>
        <p class="text-body-1 text-lg-h5 mt-10">
          {{ i.description }}
        </p>

        <!-- Extra dynamic component if present -->
        <component v-if="i.extraComponent" :is="i.extraComponent" />

        <v-btn
          :x-large="$vuetify.breakpoint.smAndUp"
          class="mr-10"
          color="primary"
          v-if="i.live_website"
          :href="i.live_website"
          :target="!i.live_website_no_target ? `_blank` : ``"
          >{{
            i.live_website_title ? i.live_website_title : "Live website"
          }}</v-btn
        >
        <v-btn
          :x-large="$vuetify.breakpoint.smAndUp"
          large
          color="source_code_button white--text"
          v-if="i.source_code"
          :href="i.source_code"
          target="_blank"
          >Source code</v-btn
        >

        <p class="text-caption mt-10" v-if="i.caption">
          {{ i.caption }}
        </p>
      </v-col>
      <v-col cols="12" md="7" class="mt-5 mt-lg-0">
        <v-img
          contain
          v-bind:src="require('../assets/' + i.img_url)"
          eager
        ></v-img>
      </v-col>
    </v-row>

    <div class="mt-16 mb-5 divider" />
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      experienceMenu: [
        {
          title: "AdviesGroep Eindhoven",
          date: "Feb 2022 - Ongoing",
          description: `Working within a team to develop an online platform aiding expats in filing Dutch taxes and accessing legal/tax services.
Improved provided services, excelling in full-stack development and AWS (cloud) integration.`,
          img_url: "expServicePic.webp",
          icons: ["$awsIcon", "$angularIcon", "$graphQLIcon"],
          live_website: "https://expat-service.nl/",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
#project-view {
  padding-top: 10vh;
  margin-bottom: 20vh;
}

.divider {
  border-top: 1px solid #656565;
}

.remove-underline {
  text-decoration: none;
}

.head-text {
  text-align: justify;
}

.subtext-divider {
  background-color: rgb(104, 104, 104);
  width: 20%;
}
</style>